(() => {
  if (window.linknextCategorySearchInitialized) return;
  window.linknextCategorySearchInitialized = true;
  const initialized = new WeakSet();
  const query = `query CategorySearch($q:String!,$after:String,$country:CountryCode!,$language:LanguageCode!,$sort:SearchSortKeys!,$reverse:Boolean!) @inContext(country:$country,language:$language) {
    search(first:24,after:$after,query:$q,types:[PRODUCT],prefix:LAST,sortKey:$sort,reverse:$reverse,unavailableProducts:SHOW) {
      nodes { ... on Product { id handle title onlineStoreUrl availableForSale featuredImage { url(transform:{maxWidth:720}) altText } priceRange { minVariantPrice { amount currencyCode } maxVariantPrice { amount currencyCode } } collections(first:20) { nodes { handle } pageInfo { hasNextPage } } } }
      pageInfo { hasNextPage endCursor }
    }
  }`;
  function init(root = document) {
    root.querySelectorAll('[data-category-search]').forEach((area) => {
      if (initialized.has(area)) return;
      initialized.add(area);
      const form = area.querySelector('form');
      const input = form.elements.category_q;
      const sort = form.elements.category_sort;
      const result = area.querySelector('[data-category-results]');
      const status = area.querySelector('[data-category-status]');
      const more = area.querySelector('[data-category-more]');
      const clear = area.querySelector('[data-category-clear]');
      const browse = area.closest('.listing').querySelector('[data-category-browse]');
      const copy = JSON.parse(area.dataset.copy);
      let controller, cursor = null, hasMore = false, scanned = 0, term = '', seen = new Set(), failed = false, appliedSort = 'relevance';
      form.querySelector('fieldset').disabled = false;
      function node(tag, text, className) {
        const el = document.createElement(tag);
        if (text !== undefined) el.textContent = text;
        if (className) el.className = className;
        return el;
      }
      function card(product) {
        const item = node('article', undefined, 'product-card');
        const link = node('a');
        link.href = area.dataset.collectionUrl + '/products/' + encodeURIComponent(product.handle);
        if (product.featuredImage) {
          const imageUrl = new URL(product.featuredImage.url);
          if (imageUrl.protocol !== 'https:') throw Error('Invalid image URL');
          const image = node('img'); image.src = imageUrl.href; image.alt = product.featuredImage.altText || product.title;
          image.loading = 'lazy'; image.width = 720; image.height = 720;
          const media = node('span', undefined, 'product-card__media'); media.append(image); link.append(media);
        }
        link.append(node('h3', product.title)); item.append(link);
        const {minVariantPrice: min, maxVariantPrice: max} = product.priceRange;
        const amount = Number(min.amount);
        if (!Number.isFinite(amount) || min.currencyCode !== area.dataset.currency) throw Error('Unexpected price context');
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:min.currencyCode}).format(amount);
        item.append(node('p', (min.amount !== max.amount ? copy.from + ' ' : '') + formatted + ' ' + min.currencyCode));
        if (!product.availableForSale) item.append(node('p', copy.sold));
        return item;
      }
      async function load(reset) {
        controller?.abort();
        const active = new AbortController(); controller = active;
        if (reset) {
          term = input.value.trim(); appliedSort = sort.value; cursor = null; hasMore = false; scanned = 0; seen = new Set(); result.replaceChildren();
        }
        const sortOrder = appliedSort;
        if (!reset) sort.value = sortOrder;
        const searching = term !== '';
        browse.hidden = searching; area.querySelector('[data-category-output]').hidden = !searching; clear.hidden = !searching;
        if (!searching) { area.removeAttribute('aria-busy'); more.hidden = true; return; }
        status.textContent = copy.loading; area.setAttribute('aria-busy','true'); more.disabled = true; more.hidden = false;
        failed = false;
        try {
          let added = 0;
          for (let batch = 0; batch < 4; batch++) {
            const timeout = setTimeout(() => active.abort(), 15000);
            let response, payload;
            try {
              response = await fetch('/api/2026-10/graphql.json', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables:{q:term,after:cursor,country:area.dataset.country,language:area.dataset.language,sort:sortOrder === 'relevance' ? 'RELEVANCE' : 'PRICE',reverse:sortOrder === 'price-descending'}}),signal:active.signal});
              payload = await response.json();
            } finally { clearTimeout(timeout); }
            if (controller !== active || !area.isConnected) return;
            if (!response.ok || payload.errors || !payload.data?.search) throw Error('Search unavailable');
            const page = payload.data.search;
            const matches = [];
            for (const product of page.nodes) {
              if (!product?.collections?.nodes) throw Error('Missing membership');
              const belongs = product.collections.nodes.some(c => c.handle === area.dataset.handle);
              if (!belongs && product.collections.pageInfo.hasNextPage) throw Error('Incomplete membership');
              if (belongs && product.onlineStoreUrl && !seen.has(product.id)) matches.push(product);
            }
            // Build the complete batch before committing cursor or DOM, so retry cannot skip failed results.
            const fragment = document.createDocumentFragment();
            for (const product of matches) fragment.append(card(product));
            if (page.pageInfo.hasNextPage && (!page.pageInfo.endCursor || page.pageInfo.endCursor === cursor)) throw Error('Invalid cursor');
            result.append(fragment); matches.forEach(p => seen.add(p.id)); added += matches.length;
            scanned += page.nodes.length; cursor = page.pageInfo.endCursor; hasMore = page.pageInfo.hasNextPage && scanned < 1000;
            if (!hasMore || added >= 12) break;
          }
          status.textContent = seen.size ? copy.shown.replace('{count}', String(seen.size)) : hasMore ? copy.keepSearching : copy.none;
          if (scanned >= 1000) status.textContent += ' ' + copy.limit;
        } catch (error) {
          if (controller !== active || !area.isConnected) return;
          failed = true; status.textContent = copy.error;
        } finally {
          if (controller === active) {
            area.removeAttribute('aria-busy'); more.disabled = false; more.hidden = !failed && !hasMore;
            more.textContent = failed ? copy.retry : copy.more;
          }
        }
      }
      function restore() {
        if (!area.isConnected) { controller?.abort(); return; }
        const url = new URL(location.href);
        input.value = url.searchParams.get('category_q') || '';
        const selected = url.searchParams.get('category_sort');
        sort.value = ['price-ascending','price-descending'].includes(selected) ? selected : 'relevance';
        load(true);
      }
      function submitSearch() {
        const url = new URL(location.href);
        url.searchParams.delete('category_q'); url.searchParams.delete('category_sort');
        if (input.value.trim()) { url.searchParams.set('category_q',input.value.trim()); url.searchParams.set('category_sort',sort.value); }
        history.pushState(null,'',url); load(true);
      }
      form.addEventListener('submit', (event) => { event.preventDefault(); submitSearch(); });
      clear.addEventListener('click', () => { input.value = ''; submitSearch(); input.focus(); });
      more.addEventListener('click', () => load(false));
      window.addEventListener('popstate', restore);
      restore();
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
